import { Controller } from '@hotwired/stimulus'
import Cookies from 'js-cookie'
const calendarTeamsExpandedCookieName = 'calendar_teams_expanded'
const calendarAllTeamsExpandedCookieName = 'calendar_all_teams_expanded'

export default class extends Controller {
  static values = { allTeamsExpanded: Boolean }
  static targets = ['body', 'expandAllTeamsToggle']

  connect() {
    //console.log('calendar--team-deployment') // | connect | this.initialUrlValue ', this.initialUrlValue)

    this.setInitialValues()
  }

  setInitialValues() {
    this.allTeamsExpandedValue = Cookies.get(calendarAllTeamsExpandedCookieName)
    //console.log('setInitialValues | after | this.filtersValue | this.startsOnValue | this.viewValue', this.filtersValue, this.startsOnValue, this.viewValue)
  }

  teamToggle(event) {
    Cookies.remove(calendarAllTeamsExpandedCookieName) // any use of expand selected team clears all teams expanded settings
    this.allTeamsExpandedValue = false
    this.expandAllTeamsToggleTarget.removeAttribute('data-expanded')

    const team_id = event.params.teamId
    const expanded = !event.delegateTarget.classList.contains('collapsed')

    let team_ids_str = Cookies.get(calendarTeamsExpandedCookieName)
    let team_ids = team_ids_str ? team_ids_str.split(',').map(el => parseInt(el)) : []

    if(expanded) {
      team_ids.push(team_id)
    } else {
      team_ids = team_ids.filter(el => el != team_id)
    }

    team_ids_str = team_ids.join(',')
    Cookies.set(calendarTeamsExpandedCookieName, team_ids_str, { sameSite: 'lax' })
  }

  teamToggleAll(event) {
    event.preventDefault()

    Cookies.remove(calendarTeamsExpandedCookieName) // any use of expand/fold all teams clears selected teams expanded settings

    this.allTeamsExpandedValue = !this.allTeamsExpandedValue

    const extra_css_query = this.allTeamsExpandedValue ? ':not(.show)' : '.show'
    const collapseElementList = this.bodyTarget.querySelectorAll(`.collapse${extra_css_query}`)
    //const collapseElementList = this.frameTarget.querySelectorAll(`.collapse${extra_css_query}`)

    const collapseList = [...collapseElementList]

    let collapse = null
    collapseList.map(collapseEl => {
      collapse = new bootstrap.Collapse(collapseEl)

      if(this.allTeamsExpandedValue) {
        collapse.show()
      } else {
        collapse.hide()
      }
    })

    if(this.allTeamsExpandedValue) {
      Cookies.set(calendarAllTeamsExpandedCookieName, true, { sameSite: 'lax' })

      event.target.setAttribute('data-expanded', 'true')
    } else {
      Cookies.remove(calendarAllTeamsExpandedCookieName)

      event.target.removeAttribute('data-expanded')
    }
  }
}
